var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.elementTag,_vm._b({tag:"component",staticClass:"optional-link",class:{ 'is-link': _vm.isLink }},'component',_vm.linkAttributes,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }